import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/products/barcode.webp'
import _imports_1 from '../../assets/img/icons/download.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_ProductDetails = _resolveComponent("ProductDetails")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "Product Details" }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row gx-0 mb-30 align-items-lg-end align-items-start" }, [
        _createElementVNode("div", { class: "col-md-6 col-7" }, [
          _createElementVNode("div", { class: "filter-left" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Barcode"
            })
          ])
        ]),
        _createElementVNode("div", { class: "col-md-6 col-5" }, [
          _createElementVNode("div", { class: "filter-right d-flex align-items-center justify-content-end flex-wrap" }, [
            _createElementVNode("a", {
              class: "btn style-five upload-btn px-xxl-6",
              onclick: "window.print();"
            }, [
              _createTextVNode(" Print "),
              _createElementVNode("img", {
                src: _imports_1,
                alt: "Image"
              })
            ])
          ])
        ])
      ], -1)),
      _createVNode(_component_ProductDetails),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ])
  ], 64))
}